import React from 'react';
import { useSelector } from 'react-redux';
import { hasNonEmptyValue } from '../../../../Lib/Any';
import { Field, NumericInput } from '../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../Core/InjectedPropsContext';
import { IWithWorksheetInjectedProps, WorksheetGridFieldSection, WorksheetRecordGrid } from '../../Core';

import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from '../../../../Lib/Object/deepEquals';

let BagsSectionBase: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const confirmRemoval = useSelector(
    pipe(createWorksheetSelector!('SamplingDetails.SampleBags.SampleBags'), (bags: Array<any>) =>
      Object.fromEntries((bags ?? []).map((v, i) => [i, hasNonEmptyValue(v.BagMass)]))
    ),
    deepEquals
  );

  return (
    <NamePrefixModifier appendNamePrefix={'SamplingDetails.SampleBags'}>
      <WorksheetGridFieldSection name="SampleBags">
        <WorksheetRecordGrid
          name={'SampleBags'}
          orientation={'vertical'}
          rowHeaderWidth={80}
          recordProps={{
            heading: 'number',
            headingLabel: 'Bag',
            preventRemove: (i) => i < 1,
            removeConfirm: {
              confirm: ({ name }) => confirmRemoval[name],
              confirmTitle: 'Bag Deletion',
              confirmText: 'Are you sure you want to remove the selected bag?',
              confirmButtonText: 'Delete Bag',
            },
          }}
          fieldSet={[
            {
              name: 'BagMass',
              component: <Field input={<NumericInput />} />,
              width: 200,
            },
            {
              name: 'IncrementsCount',
              component: <Field input={<NumericInput />} />,
              width: 200,
            },
          ]}
        />
      </WorksheetGridFieldSection>
    </NamePrefixModifier>
  );
};

const BagsSection = withInjectedProps(BagsSectionBase);
export { BagsSection };
export default BagsSection;
